import React  from "react";
import styles from './ContactAssetNavigation.module.css'
import { FaChevronUp } from "react-icons/fa";

// import {
//   DndContext,
//   closestCenter,
//   useSensor,
//   useSensors,
//   PointerSensor,
// } from "@dnd-kit/core";
import {
  // arrayMove,
  // SortableContext,
  useSortable,
  // verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {CSS} from '@dnd-kit/utilities';
// import Button from "../../Button/Button";
// import CustomDropdown from "../../CustomDropdown/CustomDropdown";
import { ReactComponent as PencilForPopup } from "../../../assets/pencilForPopup.svg";
import { ReactComponent as EyePassword } from "../../../assets/eyePassword.svg";
import { ReactComponent as GrabIcon } from "../../../assets/grabIcon.svg";
import { ReactComponent as Icon1OfText } from "../../../assets/icon1OfText.svg";
import { ReactComponent as Icon2OfText } from "../../../assets/icon2OfText.svg";
import { ReactComponent as Icon3OfText } from "../../../assets/icon3OfText.svg";
import { ReactComponent as Icon4OfText } from "../../../assets/icon4OfText.svg";
import { ReactComponent as EyePasswordSlash } from "../../../assets/eyePasswordSlash.svg";
import { ReactComponent as ContactIdentification } from "../../../assets/contactIdentificationIcon.svg";
import { ReactComponent as TextBoxIcon } from "../../../assets/TextBoxIcon.svg";
import { ReactComponent as NumberIcon } from "../../../assets/NumberIcon.svg";
import { ReactComponent as UnitOfMeasurementIcon } from "../../../assets/UnitOfMeasurementIcon.svg";
import { ReactComponent as AmountIcon } from "../../../assets/AmountIcon.svg";
import { ReactComponent as DiscountIcon } from "../../../assets/DiscountIcon.svg";
import { ReactComponent as PercentageIcon } from "../../../assets/PercentageIcon.svg";
import { ReactComponent as DateIcon } from "../../../assets/DateIcon.svg";
import { ReactComponent as DateRangesIcon } from "../../../assets/DateRangesIcon.svg";
import { ReactComponent as LocationIcon } from "../../../assets/LocationIcon.svg";
import { ReactComponent as FilesMediaIcon } from "../../../assets/FilesMediaIcon.svg";
import { ReactComponent as listIcon } from "../../../assets/ListIconNew.svg";
import { ReactComponent as CategoryIcon } from "../../../assets/CategoryIcon.svg";
import { ReactComponent as TagIcon } from "../../../assets/TagIconNew.svg";
import { ReactComponent as StatusIcon } from "../../../assets/StatusIcon.svg";
import { ReactComponent as ChecklistIcon } from "../../../assets/ChecklistIcon.svg";
import { ReactComponent as EmailIcon } from "../../../assets/EmailIconNew.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/phoneIcon.svg";
import { ReactComponent as ContactIcon } from "../../../assets/ContactIcon.svg";
import { ReactComponent as AssetIcon } from "../../../assets/AssetIcon.svg";
import { ReactComponent as UrlIcon } from "../../../assets/UrlIcon.svg";
import { ReactComponent as ChronometerIcon } from "../../../assets/ChronometerIcon.svg";
import { ReactComponent as VoiceRecorderIcon } from "../../../assets/VoiceRecorderIcon.svg";
import { ReactComponent as LanguageIcon } from "../../../assets/LanguageIcon.svg";
import { ReactComponent as FormulaIcon } from "../../../assets/FormulaIcon.svg";
import { ReactComponent as AssessmentIcon } from "../../../assets/AssessmentIcon.svg";
import DeleteButton from "../../DeleteButton/DeleteButton";
import { useTranslation } from "react-i18next";
const SortableItem = ({ parameter, 
  index, 
  showEyes, 
  showButtonAdd, 
  setShowEyes, 
  setShowButtonAdd, 
  setShowEye, 
  showEye, 
  handleHidden, 
  addParameterColumn, 
  deleteParameter,
  type
}) => {
    const {
      attributes,
      listeners,
      setActivatorNodeRef,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: parameter.id });

    const [t] = useTranslation("Contacts");
  
    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    const agentItems = [
              { id: "textBox", label: t('textBox'),Icon:TextBoxIcon },
              { id: "number", label: t('number'),Icon:NumberIcon },
              { id: "unitOfMeasurement", label: t('unitOfMeasurement'),Icon:UnitOfMeasurementIcon },
              { id: "amount", label: t('amount'),Icon:AmountIcon },
              { id: "discount", label: t('discount'),Icon:DiscountIcon },
              { id: "percentage", label: t('percentage'),Icon:PercentageIcon },
              { id: "date", label: t('date'),Icon:DateIcon },
              { id: "dateRanges", label: t('dateRanges'),Icon:DateRangesIcon },
              { id: "location", label: t('location'),Icon:LocationIcon },
              { id: "filesMedia", label: t('filesMedia'),Icon:FilesMediaIcon },
              { id: "list", label: t('list'),Icon:listIcon },
              { id: "category", label: t('category'),Icon:CategoryIcon },
              { id: "colorList", label: t('colorList'),Icon:ContactIdentification },
              { id: "tag", label: t('tag'),Icon:TagIcon },
              { id: "status", label: t('status'),Icon:StatusIcon },
              { id: "checklist", label: t('checklist'),Icon:ChecklistIcon },
              { id: "email", label: t('email'),Icon:EmailIcon },
              { id: "phone", label: t('phone'),Icon:PhoneIcon },
              { id: "contact", label: t('contact'),Icon:ContactIcon },
              { id: "asset", label: t('asset'),Icon:AssetIcon },
              { id: "url", label: t('Url'),Icon:UrlIcon },
              { id: "chronometer", label: t('chronometer'),Icon:ChronometerIcon },
              { id: "voiceRecorder", label: t('voiceRecorder'),Icon:VoiceRecorderIcon },
              { id: "language", label: t('language'),Icon:LanguageIcon },
              { id: "formula", label: t('formula'),Icon:FormulaIcon },
              { id: "assessment", label: t('assessment'),Icon:AssessmentIcon },
            ];

        const itemSelected = agentItems.find(item => item.id === parameter.type);

  
    return (
      <li
        className={type === "popup" && styles.displayList}
        ref={setNodeRef}
        style={style}
        onMouseEnter={() => {
          setShowEyes(index);
          setShowButtonAdd(index);
        }}
        onMouseLeave={() => {
          setShowEyes(null);
          setShowButtonAdd(null);
        }}
      >
        <div
          className={`${styles.infoParameterItem} ${parameter.id === "cat1" ? styles.lessCategoryContainer : type === "popup" ? styles.textAndDragContainer : ""}`}
        >
          <GrabIcon
            ref={setActivatorNodeRef}
            {...listeners}
            {...attributes}
            style={{ cursor: "grab", margin: "0 10px", outline: "none" }}
          />
          {/* {parameter.id === "cat1" ? (
            <div className={styles.lessCategory}>
              <FaChevronUp size={12} fill={"#8E8E93"} />
              <span>{parameter.name}</span>
              <PencilForPopup />
            </div>
          ) : type === "popup" ? (
            <div className={styles.textContainer}>
              {parameter.id === "texto1" ? (
                <Icon1OfText />
              ) : parameter.id === "texto2" ? (
                <Icon2OfText />
              ) : parameter.id === "texto3" ? (
                <Icon3OfText />
              ) : (
                <Icon4OfText />
              )}
              <div className={styles.text}>
                <span className={styles.span1}>Texto</span>
                <span className={styles.span2}>Valor</span>
              </div>
            </div>
          ) : (
            <div className={styles.textParameter}>
              {itemSelected && itemSelected?.Icon && (
                <itemSelected.Icon fill={'black'} color={'black'} className={styles.iconParameter} />)}
             {parameter.name}
            </div>
          )} */}

           <div className={styles.textParameter}>
              {itemSelected && itemSelected?.Icon && (
                <itemSelected.Icon fill={'black'} color={'black'} className={styles.iconParameter} />)}
             {parameter.name}
            </div>
        </div>
        <span
          className={`${styles.icon} ${
            showEyes === index ? styles.visible : ""
          }`}
          onClick={() => setShowEye(!showEye)}
        >
          {parameter.hasOwnProperty("hidden") &&
            (parameter?.hidden ? (
              <EyePasswordSlash
                onClick={() => handleHidden(false, parameter)}
                className={styles.eye}
              />
            ) : (
              <EyePassword
                onClick={() => handleHidden(true, parameter)}
                className={styles.eye}
              />
            ))}
        </span>

        {parameter.id !== "cat1" &&
          showButtonAdd === index &&
          !parameter.hasOwnProperty("hidden") && (
            <div
              className={styles.addParameterColumn}
              onClick={() => addParameterColumn(parameter.name, parameter.id, parameter.type)}
            >
              +
            </div>
          )}
        <DeleteButton
          action={() => deleteParameter(parameter)}
          // CustonIcon={WhiteXCloseIcon}
          // customIconStyles={{
          //   height: "30px",
          //   minWidth: "30px",
          //   background: "#6E6E80",
          // }}
        />
      </li>
    );
  };
  
  export default SortableItem